import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { enums } from "../../constants/enum";
import { campaignValidationSchema } from "../../schemas/campaign";
import useCampaignService from "../../services/api/campaignService";

import { AddIcon } from "../../assets/icons";
import { Button, PageTitle, Section } from "../../components";
import { DateInput, TextInput } from "../../components/forms";

import "./CampaignsPage.scss";

function EditCampaignPage() {
  const initialValues = {
    name: "",
    place: "",
    date: "",
    orderNumberSequencePrefix: "",
  };
  const { getCampaignById, updateCampaign, queryKey } = useCampaignService();
  const { campaignId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const updateCampaignMutation = useMutation({
    mutationFn: updateCampaign,
  });

  const { data: payload } = useQuery({
    queryKey: [queryKey, campaignId],
    queryFn: () => getCampaignById(campaignId),
    enabled: !!campaignId,
  });

  function handleEditCampaign(values) {
    updateCampaignMutation.mutate(
      { payload: values, id: campaignId },
      {
        onSuccess: async (payload) => {
          await queryClient.resetQueries({
            queryKey: [queryKey],
          });
          toast.success(payload?.message);
          navigate("/campaigns", { replace: true });
        },
        onError: (e) => {
          toast.error(e.response.data.payload.message || enums.DEFAULT_ERROR_MESSAGE);
        },
      }
    );
  }

  return (
    <div className="page add-campaign-page">
      <PageTitle text="Edit Campaign Details" prev="/campaigns" />

      <Section className="campaign-form">
        <Formik
          initialValues={
            {
              name: payload?.campaign?.name,
              place: payload?.campaign?.place,
              date: payload?.campaign?.date?.split("T")[0],
              orderNumberSequencePrefix: payload?.campaign?.orderNumberSequencePrefix,
            } || initialValues
          }
          validationSchema={campaignValidationSchema}
          enableReinitialize
          onSubmit={handleEditCampaign}
        >
          <Form>
            <TextInput name="name" label="Campaign name" placeholder="Campaign name" />
            <TextInput name="place" label="Campaign location" placeholder="Campaign location" />
            <div className="input-group">
              <DateInput name="date" label="Date" />
              <TextInput name="orderNumberSequencePrefix" label="Order number prefix" placeholder="Type here" />
            </div>
            <Button text="Update Campaign" type="submit" icon={<AddIcon />} />
          </Form>
        </Formik>
      </Section>
    </div>
  );
}

export default EditCampaignPage;
